<template>
  <input :value="value" />
</template>

<style lang="scss">
.cosmo-range-slider .irs {
  font-family: 'bitter';
}
</style>

<script>
import 'ion-rangeslider'

export default {
  props: ['options', 'value'],
  mounted() {
    let vm = this
    $(this.$el)
      .ionRangeSlider(this.extended_options)
      // emit event on change.
      .on('change', function() {
        vm.$emit('input', this.value)
      })
    this.$slider = $(this.$el).data('ionRangeSlider')
  },
  computed: {
    extended_options() {
      return {
        extra_classes: 'cosmo-range-slider',
        skin: 'square',
        ...this.options,
      }
    },
  },
  watch: {
    extended_options(value) {
      this.$slider.update(value)
    },
  },
  destroyed() {
    this.$slider.destroy()
  },
}
</script>
